export const ProductData = [
  // {
  //   id: "sc",
  //   image: require("../images/singlecover.png"),
  //   title: "Single Cover Spacers / Cover Blocks",
  //   details: [
  //     { code: "PRM-30/40", size: "30/40", packing: "300" },
  //     { code: "PRM-20/25", size: "20/25", packing: "300 " },
  //     { code: "PRM-20/40", size: "20/25/30/40", packing: "200 " },
  //     { code: "PRM-20/50", size: "20/25/40/50", packing: "200 " },
  //     { code: "PRM-35/50", size: "35/40/45/50", packing: "200" },
  //     { code: "PRM-45/57", size: "45/57", packing: "150" },
  //     { code: "PRM-60/75", size: "60/65/75", packing: "50" },
  //   ]
  // },
  // {
  //   id: "mc",
  //   image: require("../images/multicover.png"),
  //   title: "Multi Cover Spacers / Cover Blocks",
  //   details: [
  //     { code: "PRM-30/40", size: "30/40", packing: "300" },
  //     { code: "PRM-20/25", size: "20/25", packing: "300 " },
  //     { code: "PRM-20/40", size: "20/25/30/40", packing: "200 " },
  //     { code: "PRM-20/50", size: "20/25/40/50", packing: "200 " },
  //     { code: "PRM-35/50", size: "35/40/45/50", packing: "200" },
  //     { code: "PRM-45/57", size: "45/57", packing: "150" },
  //     { code: "PRM-60/75", size: "60/65/75", packing: "50" },
  //   ]
  // },
  // {
  //   id: "hd",
  //   image: require("../images/heavyduty.png"),
  //   title: "Heavy Duty Spacers / Cover Blocks",
  //   details: [
  //     { code: "PRM-30/40", size: "30/40", packing: "300" },
  //     { code: "PRM-20/25", size: "20/25", packing: "300 " },
  //     { code: "PRM-20/40", size: "20/25/30/40", packing: "200 " },
  //     { code: "PRM-20/50", size: "20/25/40/50", packing: "200 " },
  //     { code: "PRM-35/50", size: "35/40/45/50", packing: "200" },
  //     { code: "PRM-45/57", size: "45/57", packing: "150" },
  //     { code: "PRM-60/75", size: "60/65/75", packing: "50" },
  //   ]
  // },

  {
    id: "lb",
    image: require("../images/KANDA.png"),
    title: "Cover Kanda",
    details: [
      { code: "PRK-100", size: "100mm", packing: "100" },
      { code: "PRK-150", size: "150mm", packing: "50 " },
      { code: "PRK-200", size: "200mm", packing: "25" },
      { code: "PRK-230", size: "230mm", packing: "25 " },
      { code: "PRK-250", size: "250mm", packing: "25" },
      { code: "PRK-300", size: "300mm", packing: "10" },
      { code: "PRK-350", size: "350mm", packing: "10" },
      { code: "PRK-400", size: "400mm", packing: "10" },
      { code: "PRK-450", size: "450mm", packing: "10" },
      { code: "PRK-500", size: "500mm", packing: "10" },
      { code: "PRK-600", size: "600mm", packing: "10" },
    ]
  },{
    id: "cc",
    image: require("../images/cloumcover.png"),
    title: "Column Cover Blocks",
    details: [
      { code: "PRC-25", size: "25mm", packing: "200" },
      { code: "PRC-30", size: "30mm", packing: "200" },
      { code: "PRC-40", size: "40mm", packing: "100" },
      { code: "PRC-45", size: "45mm", packing: "100 " },
      { code: "PRC-50", size: "50mm", packing: "50 " },
      { code: "PRC-35", size: "35mm", packing: "150 " },
    ]
  },{
    id: "fc",
    image: require("../images/Footing_cover.png"),
    title: "Footing Cover Blocks",
    details: [
      { code: "PRF-50", size: "50mm", packing: "100 " },
      { code: "PRF-60", size: "35mm", packing: "100 " },
      { code: "PRF-75", size: "75mm", packing: "50" },
      { code: "PRF-100", size: "100mm", packing: "50 " },
    ]
  },{
    id: "rc",
    image: require("../images/rAFT_COVER.png"),
    title: "Raft Footing Cover Blocks",
    details: [
      { code: "PRR-40", size: "40mm", packing: "100" },
      { code: "PRR-50", size: "50mm", packing: "150" },
      { code: "PRR-60", size: "60mm", packing: "75" },
      { code: "PRR-75", size: "75mm", packing: "50 " },
      { code: "PRR-100", size: "100mm", packing: "15 " },
    ]
  },{
    id: "pc",
    image: require("../images/PILE_COVER.png"),
    title: "Pile Cover Blocks",
    details: [
      { code: "PRP-25", size: "25mm", packing: "200" },
      { code: "PRP-30", size: "30mm", packing: "150" },
       { code: "PRP-35", size: "35mm", packing: "150 " },
      { code: "PRP-40", size: "40mm", packing: "100" },
      { code: "PRP-50", size: "50mm", packing: "50 " },
      { code: "PRP-65", size: "65mm", packing: "120 " },
      { code: "PRP-75", size: "75mm", packing: "16 " },
    ]
  }
  ,{
    id: "ma",
    image: require("../images/muiltcave.png"),
    title: "Muilti Cavity Blocks",
     details: [
      { code: "PRM-30/40", size: "30/40", packing: "300" },
      { code: "PRM-20/25", size: "20/25", packing: "300 " },
      { code: "PRM-20/40", size: "20/25/30/40", packing: "200 " },
      { code: "PRM-20/50", size: "20/25/40/50", packing: "200 " },
      { code: "PRM-35/50", size: "35/40/45/50", packing: "200" },
      { code: "PRM-45/57", size: "45/57", packing: "150" },
      { code: "PRM-60/75", size: "60/65/75", packing: "50" },
    ]
  },
];
